import API from "../../../utils/api";

export const getShippingRulesApi = async (filters) => {
  const response = await API.get("settings/shipping-rule", { params: filters });
  return { response };
};

export const addShippingRulesApi = async (data) => {
  const response = await API.post("settings/shipping-rule", data);
  return { response };
};

export const updateShippingRulesApi = async (data, id) => {
  const response = await API.put(`settings/shipping-rule/${id}`, data);
  return { response };
};

export const deleteShippingRulesApi = async (id) => {
  const response = await API.delete(`settings/shipping-rule/${id}`);
  return { response };
};
